import { GLOBAL } from 'saddlebag-browser';

const $document = GLOBAL.getDocument();

const NewRelicAgentScriptSrcTag = 'js-agent.newrelic.com/nr-spa';

// Waiting the New Relic agent script ready before redirecting to resolve NR log missing problem.
export const waitForNewRelicAgentScript = (callback: () => void) => {
  let callbackCalled = false;

  const handleScriptLoad = () => {
    if (!callbackCalled) {
      // Delay the callback to ensure the NR agent is ready and NR ajax has enough time to send logs
      setTimeout(() => {
        callbackCalled = true;
        callback();
      }, 300);
    }
  };

  // Check if the NR agent script is already loaded
  const newRelicAgentScript = $document.querySelector(
    `script[src*="${NewRelicAgentScriptSrcTag}"]`,
  );
  if (newRelicAgentScript instanceof HTMLScriptElement) {
    newRelicAgentScript.onload = handleScriptLoad;
    return;
  }

  // Observe the document head if the NR agent script is not loaded yet
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeName === 'SCRIPT' && node instanceof HTMLScriptElement) {
            const script = node;
            // Check the NR agent script: https://js-agent.newrelic.com/nr-spa-1.262.0.min.js
            if (script.src.includes(NewRelicAgentScriptSrcTag)) {
              script.onload = handleScriptLoad;
            }
          }
        });
      }
    });
  });

  observer.observe($document.head, { childList: true });

  // Clean up the observer and trigger callback immediately after 10 seconds
  setTimeout(() => {
    observer.disconnect();
    handleScriptLoad();
  }, 10 * 1000);
};
